export enum StyleBundle {
  SHOP_LANDING_BUNDLE = 'shop-landing-bundle.css',
  SHOP_LIST_BUNDLE = 'shop-list-bundle.css',
  PDP_BUNDLE = 'pdp-page-bundle.css',
  REGISTRATION_BUNDLE = 'registration-bundle.css',
  CART_BUNDLE = 'cart-bundle.css',
  ORDER_CONFIRMATION_BUNDLE = 'order-confirmation-bundle.css'
}
